export const templateStepDropdownOptions = [
    {label: 'days before', value: 'day_before'},
    {label: 'days after', value: 'day_after'},
    {label: 'hours before', value: 'hour_before'},
    {label: 'hours after', value: 'hour_after'},
]